import * as React from 'react'
// Note: Only loading vimeo to reduce the bundle size  https://www.npmjs.com/package/react-player
import ReactPlayer from 'react-player/vimeo.js'

import { CSSWrapper } from '~/utilities/css-wrapper/CSSWrapper'
import { Override } from '~/utilities/types'

type VideoProps = Override<
  React.ComponentProps<typeof ReactPlayer>,
  {
    id: string
    ratio?: number
    className?: string
  }
>

export const Video = React.forwardRef<any, VideoProps>(
  ({ id, ratio = 9 / 16, className, ...remainingProps }, ref) => (
    <CSSWrapper className={className}>
      <div
        style={{ '--ratio': `${ratio * 100}%` }}
        className="relative h-0 w-full overflow-hidden rounded-sm pt-(--ratio)"
      >
        <ReactPlayer
          {...remainingProps}
          role="figure"
          url={`https://player.vimeo.com/video/${id}`}
          height="100%"
          width="100%"
          ref={ref}
          className="absolute top-0 left-0"
        />
      </div>
    </CSSWrapper>
  )
)

Video.displayName = 'Video'
